import {Link} from "react-router-dom";

export const NoMatch = () => {
  return (
    <div
      className="min-h-screen bg-gray-100 flex flex-col justify-center items-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <h1 className="text-9xl font-extrabold text-gray-900">404</h1>
        <h2 className="mt-6 text-3xl font-bold text-gray-900">Page Not Found</h2>
        <div className="mt-8">
          <Link to="https://fortworx.com" className="text-blue-600 hover:text-blue-800 transition-colors duration-300">
            Visit Fortworx
          </Link>
        </div>
      </div>
      <div className="mt-16 text-sm text-gray-500">Powered by Fortworx</div>
    </div>
  )
};

